// extracted by mini-css-extract-plugin
module.exports = {"AccountForm__content":"styles_AccountForm__content__UAbqz"};